const imageUrl = 'http://44.224.236.138:3009';

export default imageUrl;